import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../../../config';
import { apiFetch } from '../../../../apiFetch';
import './AdminPlayerCareerReview.css';

const AdminPlayerCareerReview = () => {
    const [loading, setLoading] = useState(true);
    const [reports, setReports] = useState([]);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const res = await apiFetch('/api/admin/reports');

                if (!res.ok) {
                    throw new Error(await res.text());
                }

                const data = await res.json();
                setReports(data);

            } catch (err) {
                console.error(err);
                setError(err.message || 'An unexpected error occurred while loading reports.');
            } finally {
                setLoading(false);
            }
        };

        fetchReports();
    }, []);


    const getFrontendLink = (raw) => {
        if (!raw) return null;

        // block old localhost links
        if (raw.includes('localhost')) return null;

        // absolute ok
        if (/^https?:\/\//i.test(raw)) return raw;

        // relative -> current frontend origin
        return `${window.location.origin}${raw.startsWith('/') ? '' : '/'}${raw}`;
    };


    const getFileUrl = (rawUrl) => {
        if (!rawUrl) return null;
        if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
        return `${BASE_URL}${rawUrl.startsWith('/') ? '' : '/'}${rawUrl}`;
    };





    const filteredReports = reports.filter((report) => {
        const fullName = report?.player?.fullName?.toLowerCase() || '';
        const username = report?.player?.username?.toLowerCase() || '';
        const term = searchTerm.toLowerCase();

        return fullName.includes(term) || username.includes(term);
    });

    return (
        <div className="admin-player-reports">
            <h2>Player Career Reporting</h2>

            <div className="search-bar-container">
                <input
                    type="text"
                    placeholder="Search by Player Name or Username"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
            </div>

            {loading && <p>Loading career reports...</p>}
            {error && <p className="error">{error}</p>}
            {!loading && filteredReports.length === 0 && (
                <p style={{ textAlign: 'center' }}>No career reports found.</p>
            )}

            <div className="report-list">
                {filteredReports.map((report) => (
                    <div key={report.id} className="report-card">
                        <h4>{report.typeOfUpdate || 'Career Update'}</h4>

                        <p>
                            <strong>Description:</strong>{' '}
                            {report.description || 'N/A'}
                        </p>

                        <p>
                            <strong>Date:</strong>{' '}
                            {report.eventDate
                                ? new Date(report.eventDate).toLocaleDateString()
                                : 'N/A'}
                        </p>

                        <p>
                            <strong>Signed / Worked With:</strong>{' '}
                            {report.contactName || 'N/A'}
                        </p>

                        <p>
                            <strong>VSN Profile Link:</strong>{' '}
                            {report.profileLink ? (
                                <a
                                    href={getFrontendLink(report.profileLink)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {report.profileLink}
                                </a>
                            ) : (
                                'N/A'
                            )}
                        </p>

                        <p>
                            <strong>Organization:</strong>{' '}
                            {report.organizationName || 'N/A'}
                        </p>

                        <p>
                            <strong>Location:</strong>{' '}
                            {report.location || 'N/A'}
                        </p>

                        <p>
                            <strong>Contact Info:</strong>{' '}
                            {report.contactInfo || 'N/A'}
                        </p>

                        {report.fileUrls?.length > 0 && (
                            <div className="files-section">
                                <strong>Proof Files:</strong>
                                <ul>
                                    {report.fileUrls.map((url, i) => (
                                        <li key={i}>
                                            <a
                                                href={getFileUrl(url)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {url.includes('.mp4')
                                                    ? '🎥 Video File'
                                                    : '📄 File'}{' '}
                                                {i + 1}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {report.player && (
                            <div className="submitted-by">
                                <p>
                                    <strong>Submitted By:</strong>
                                </p>
                                <ul>
                                    <li>
                                        <strong>Full Name:</strong>{' '}
                                        {report.player.fullName}
                                    </li>
                                    <li>
                                        <strong>Username:</strong>{' '}
                                        {report.player.username}
                                    </li>
                                    <li>
                                        <strong>Profile:</strong>{' '}
                                        {getFrontendLink(report.player.internalProfileLink) ? (
                                            <a
                                                href={getFrontendLink(report.player.internalProfileLink)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View Profile
                                            </a>
                                        ) : (
                                            'N/A'
                                        )}

                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminPlayerCareerReview;

